import { Link } from 'react-router-dom';
import MovieCard from '@/components/base/MovieCard';
import { hotTVShows, hotVariety } from '@/mocks/movies';

export default function LatestUpdates() {
  return (
    <section className="py-8 px-4 md:px-6 max-w-7xl mx-auto">
      {/* TV Shows */}
      <div className="mb-10">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
              热门电视剧
            </h2>
          </div>
          <Link
            to="/category/tv"
            className="flex items-center gap-1 text-foreground-500 hover:text-primary-500 text-sm transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {hotTVShows.map((show) => (
            <MovieCard key={show.id} item={show} />
          ))}
        </div>
      </div>

      {/* Variety Shows */}
      <div>
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
              热门综艺
            </h2>
          </div>
          <Link
            to="/category/variety"
            className="flex items-center gap-1 text-foreground-500 hover:text-primary-500 text-sm transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {hotVariety.map((show) => (
            <MovieCard key={show.id} item={show} />
          ))}
        </div>
      </div>
    </section>
  );
}